import { FormEntryField } from '../../type'

export const LabelFormItem = ({value}: FormEntryField<string>) =>
  (<span className='f-medium'>{value}</span>)